<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <v-card>
      <v-form
        ref="userForm"
        lazy-validation
      >
        <v-card-title>
          <span class="headline">Invite User</span>
          <v-spacer />
          <v-btn
            icon
            @click="close"
          >
            <v-icon color="error">
              mdi-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-container class="px-0">
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field
                  v-model="user.name"
                  label="User Name*"
                  :rules="nameRules"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="user.email"
                  label="E-mail*"
                  :rules="emailRules"
                  outlined
                  dense
                />
              </v-col>
              <v-col
                class="mt-n3"
                cols="12"
              >
                <v-switch
                  v-model="user.isAdmin"
                  label="Admin"
                />
              </v-col>
              <v-col
                v-if="!user.isAdmin"
                cols="12"
              >
                <v-autocomplete
                  v-model="user.roleId"
                  :items="roles"
                  item-text="name"
                  item-value="id"
                  label="Role*"
                  :rules="roleRules"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider class="mt-n3" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            @click="close"
          >
            Close
          </v-btn>
          <v-btn
            color="success"
            :disabled="!isFormValid || loader"
            :loading="loader"
            @click="saveUser"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UserForm",
  props: {
    open: Boolean
  },
  data() {
    return {
      dialog: false,
      loader: false,
      user: { name: "", email: "", isAdmin: true, roleId: 0 },
      roles: [],
      nameRules: [
        v => (!!v && v.trim().length > 0) || "Name is required"
      ],
      emailRules: [
        v => (!!v && v.trim().length > 0) || "Email is required",
        v => /^[a-zA-Z0-9._%+-]+@digitory\.com$/.test(v) || "Email must be a valid @digitory.com address"
      ],
      roleRules: [
        v => !!v || "Role is required"
      ]
    };
  },
  computed: {
    isFormValid() {
      const nameOk = this.nameRules.every(r => r(this.user.name) === true);
      const emailOk = this.emailRules.every(r => r(this.user.email) === true);
      const roleOk = this.user.isAdmin || this.roleRules.every(r => r(this.user.roleId) === true);
      return nameOk && emailOk && roleOk;
    }
  },
  watch: {
    open(val) {
      this.dialog = val;
      if (val) {
        this.reset();
        this.getRoles();
      }
    },
    dialog(val) {
      this.$emit("update:open", val);
    }
  },
  methods: {
    getRoles() {
      this.$http.get(`${this.ADMIN_API_URL}/activeRoles`).then(res => {
        this.roles = res.body;
      });
    },
    saveUser() {
      if (!this.$refs.userForm.validate()) return;
      this.loader = true;
      this.$http.post(`${this.ADMIN_API_URL}/users`, this.user)
        .then(
              (data) => {
                this.$emit("refresh");
                this.handleSuccess(data.body);
                this.close();
              },
              (failure) => {
                this.handleFailure(failure);
              }
            )
        .finally(() => {
          this.loader = false;
        });
    },
    reset() {
      this.user = { name: "", email: "", isAdmin: true, roleId: 0 };
      this.$nextTick(() => {
        if (this.$refs.userForm) this.$refs.userForm.resetValidation();
      });
    },
    close() {
      this.dialog = false;
    },
    handleSuccess: function (response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
      this.$emit("reload");
    },
    handleFailure: function (failure) {
			let msg = failure.body.message || "Error";
			let errors = failure.body.errors;
			if (errors && errors.Name) {
				msg = errors.Name;
			}
			if (errors && errors.EmailID) {
				msg = errors.EmailID;
			}
      
      if (errors && errors["UserInfo.Email"]) {
        msg = errors["UserInfo.Email"];
      }

			this.$store.commit("showSnackbar", {
				message: msg,
				color: "error"
			});
		}
  }
};
</script>